



import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import GeoMapMarker from '@/components/organisms/GeoMap/GeoMapMarker.vue';
import { POINT_MARKER_ICON_CONFIG } from '@/components/organisms/GeoMap/constants/mapSettings';
import MarkerClusterer from '@googlemaps/markerclustererplus';

@Component({
  name: 'GeoMapMarkerClustererList',
  components: {
    GeoMapMarker,
  },
})
export default class GeoMapMarkerClustererList extends Vue {
  @Prop() public google: any;

  @Prop() public map: any;

  @Prop() public markers: any;

  @Prop() protected markersNeedUpdate!: any;

  @Prop({ default: false }) protected autoZoom!: boolean;

  @Prop({ default: false }) protected autoCenter!: boolean;

  @Prop({ default: false }) protected autoZoomOnce!: boolean;

  @Prop({ default: false }) protected autoCenterOnce!: boolean;

  protected markerClusterer: any = null;

  protected selectedMarkerObject: any = null;

  protected selectedLastMarkerObject: any = null;

  protected lastMarketObject: any = null;

  protected prepareMarkerIcon(icon: any) {
    if (typeof icon === 'string') {
      return icon;
    }
    const iconPrepared: any = {
      ...icon,
    };

    if (icon.anchor) {
      iconPrepared.anchor = new this.google.maps.Point(icon.anchor[0], icon.anchor[1]);
    }
    return iconPrepared;
  }

  protected generateMarkerObject(marker: any) {
    const markerObject = new this.google.maps.Marker({
      position: marker.data.position,
      marker: marker.data,
      icon: this.prepareMarkerIcon(marker.icon || POINT_MARKER_ICON_CONFIG),
    });
    markerObject.addListener('click', () => {
      this.selectedLastMarkerObject = this.selectedMarkerObject;
      this.selectedMarkerObject = markerObject;
      this.onSelectMarker(marker);
    });
    return markerObject;
  }

  protected generateMarkerObjects(markers: any) {
    return Object.keys(markers).map((key: any) => {
      const marker: any = markers[key];
      return this.generateMarkerObject(marker);
    });
  }

  protected onSelectMarker(marker: any) {
    this.$emit('onSelect', marker);
  }

  @Watch('markersNeedUpdate', { deep: true })
  protected onMarkersNeedUpdate() {
    if (this.markerClusterer) {
      if (this.selectedMarkerObject) {
        this.lastMarketObject = this.selectedMarkerObject;
        this.markerClusterer.removeMarker(this.selectedMarkerObject);
      }
      if (this.selectedLastMarkerObject && this.markersNeedUpdate[0]) {
        this.markerClusterer.removeMarker(this.selectedLastMarkerObject);
      }
      if (this.markersNeedUpdate[0]) {
        this.selectedMarkerObject = this.generateMarkerObject(this.markersNeedUpdate[0]);
        this.markerClusterer.addMarker(this.selectedMarkerObject);
      } else {
        this.selectedMarkerObject = this.lastMarketObject;
      }
      if (this.markersNeedUpdate[1]) {
        this.selectedLastMarkerObject = this.generateMarkerObject(this.markersNeedUpdate[1]);
        this.markerClusterer.addMarker(this.selectedLastMarkerObject);
      }
    }
  }

  @Watch('markers', { immediate: true })
  protected onChangeMarkersImmediate() {
    const markerObjects: any = this.generateMarkerObjects(this.markers);
    if (!this.markerClusterer) {
      // eslint-disable-next-line
      this.markerClusterer = new MarkerClusterer(this.map, markerObjects, {
        maxZoom: 18,
        averageCenter: true,
        styles: [
          {
            anchorText: [20, 27],
            anchorIcon: [26, 52],
            width: 52,
            height: 52,
            textColor: '#283237',
            fontFamily: 'IBM Plex Sans',
            fontWeight: 'SemiBold',
            textSize: 11,
            url: `${process.env.VUE_APP_URL_PREFIX ? process.env.VUE_APP_URL_PREFIX : '/'}img/MapCluster1.png`,
          },
          {
            anchorText: [22, 29],
            anchorIcon: [28, 56],
            width: 56,
            height: 56,
            textColor: '#283237',
            fontFamily: 'IBM Plex Sans',
            fontWeight: 'SemiBold',
            textSize: 11,
            url: `${process.env.VUE_APP_URL_PREFIX ? process.env.VUE_APP_URL_PREFIX : '/'}img/MapCluster2.png`,
          },
          {
            anchorText: [27, 34],
            anchorIcon: [33, 66],
            width: 66,
            height: 66,
            textColor: '#283237',
            fontFamily: 'IBM Plex Sans',
            fontWeight: 'SemiBold',
            textSize: 11,
            url: `${process.env.VUE_APP_URL_PREFIX ? process.env.VUE_APP_URL_PREFIX : '/'}img/MapCluster3.png`,
          },
          {
            anchorText: [33, 40],
            anchorIcon: [39, 78],
            width: 78,
            height: 78,
            textColor: '#283237',
            fontFamily: 'IBM Plex Sans',
            fontWeight: 'SemiBold',
            textSize: 11,
            url: `${process.env.VUE_APP_URL_PREFIX ? process.env.VUE_APP_URL_PREFIX : '/'}img/MapCluster4.png`,
          },
          {
            anchorText: [39, 45],
            anchorIcon: [45, 90],
            width: 90,
            height: 90,
            textColor: '#283237',
            fontFamily: 'IBM Plex Sans',
            fontWeight: 'SemiBold',
            textSize: 11,
            url: `${process.env.VUE_APP_URL_PREFIX ? process.env.VUE_APP_URL_PREFIX : '/'}img/MapCluster5.png`,
          },
        ],
      });
    } else {
      this.markerClusterer.clearMarkers();
      this.markerClusterer.addMarkers(markerObjects);
    }
    if (this.autoZoomOnce) {
      this.updateAutoZoom();
    }
    if (this.autoCenterOnce) {
      this.updateAutoCenter();
    }
  }

  @Watch('markers', { immediate: true, deep: true })
  protected onChangeMarkers() {
    if (this.autoZoom) {
      this.updateAutoZoom();
    }
    if (this.autoCenter) {
      this.updateAutoCenter();
    }
  }

  protected getBounds() {
    const bounds: any = new this.google.maps.LatLngBounds();
    if (Array.isArray(this.markers)) {
      this.markers.forEach((marker: any) => {
        const loc = new this.google.maps.LatLng(marker.data.position.lat, marker.data.position.lng);
        bounds.extend(loc);
      });
    } else {
      Object.keys(this.markers).forEach((key: any) => {
        const marker: any = this.markers[key];
        const loc = new this.google.maps.LatLng(marker.data.position.lat, marker.data.position.lng);
        bounds.extend(loc);
      });
    }
    return bounds;
  }

  protected updateAutoZoom() {
    this.map.fitBounds(this.getBounds());
  }

  protected updateAutoCenter() {
    this.map.panToBounds(this.getBounds());
  }
}
